$(".trigger").click(function (e) {
    $("#trigger"). toggleClass("is-open");
    $("#mobile-nav").toggleClass("is-open");
    return false;
});
